import React, { useEffect } from "react";
import "./HomePage.scss";
import HomeCarousel from "./HomeCarousel";
import AboutUs from "./AboutUS";
import Benefits from "./Benefits";
import HowToRegister from "./HowToRegister";
import ProcessOverview from "./ProcessOverview";
import FAQs from "./FAQs";
import MediaCenter from "./MediaCenter";
import SystemOverview from "./SystemOverview";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Menubar } from "primereact/menubar";
import { MenuItem } from "primereact/menuitem";
import { useTranslation } from "react-i18next";
import { isArabic } from "src/utils/helpers";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
export default function HomePage() {
  const { t } = useTranslation(["common"]);
  const items: MenuItem[] = [
    {
      label: t("homePage.aboutUs.title"),
      url: "#about-us",
    },
    {
      label: t("homePage.systemOverview.label"),
      url: "#system-overview",
    },
    {
      label: t("homePage.benefits.label"),
      url: "#benefits",
    },
    {
      label: t("homePage.howToRegister.label"),
      url: "#how-to-register",
    },
    {
      label: t("homePage.processOverview.label"),
      url: "#process-overview",
    },
    {
      label: t("homePage.faqs.title"),
      url: "#faqs",
    },
    {
      label: t("homePage.mediaCenter.title"),
      url: "#media-center",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const staticMenu = document.getElementById("static-menu");
      if (staticMenu) {
        const header = document.getElementById("app-header-container");
        const headerHeight = header ? header.offsetHeight : 160;
        if (window.scrollY <= headerHeight) {
          staticMenu.style.top = `${headerHeight - window.scrollY}px`;
        } else staticMenu.style.top = "0";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.slice(1));
      if (element) {
        element.scrollIntoView();
      }
    }
  }, []);

  return (
    <main
      className="home-page"
      style={{ direction: isArabic() ? "rtl" : "ltr" }}
    >
      <div
        className="top-icon"
        role="button"
        tabIndex={0}
        onClick={() => (window.location.href = "#home")}
        onKeyPress={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            window.location.href = "#home";
          }
        }}
      >
        <div className="icon-container d-flex align-items-center justify-content-center flex-column">
          <span className="icon-bg">
            <ArrowUpwardIcon />
          </span>
          <span className="top-icon-text">{t("top")}</span>
        </div>
      </div>
      <div className="home-menubar" id="static-menu">
        <Menubar
          model={items}
          menuIcon={
            <div className="d-flex align-items-center w-100 ">
              <span>{t("footer.home")}</span>
              <KeyboardArrowDownIcon />
            </div>
          }
        />
      </div>
      <HomeCarousel />
      <div className="page-container">
        <AboutUs />
      </div>
      <SystemOverview />
      <div className="page-container">
        <Benefits />
      </div>
      <HowToRegister />
      <div className="page-container">
        <ProcessOverview />
      </div>
      <FAQs />
      <div className="page-container">
        <MediaCenter />
      </div>
    </main>
  );
}
